import React from 'react';
import QRCode from 'qrcode.react';
import { isWeixin, isWeixinWork, isPC, lockBody, unLockBody } from '../../../utils/common';
import {isMiniApp} from '../../../utils/miniApp';
import './index.scss';
export const ShareTip = props => {
	function handleClick() {
		props.onClick();
		unLockBody();
	}
	lockBody();
	let wx = !isWeixin() && !isWeixinWork();
	let pc = isPC();
	let classNames = wx ? 'copyright-share-tip pc' : 'copyright-share-tip';
	let globalFlag = 0;
	let qrCodeSize = 140;
	if (pc) {
		qrCodeSize = 190;
	}
	(async () => {
		globalFlag = await isMiniApp();
		if (globalFlag === 1) {
			let dom = document.querySelector(".copyright-share-tip");
			dom.classList.add('copyright-share-tip-miniapp');
		}
	})();
	function geneQrCode() {
		let url = window.location.origin + props.path + props.id;
		console.log('shared url', url);
		// debugger;
		return url;
	}
	return (
		<div className={classNames} onClick={handleClick} style={{color: '#fff'}}>
			{wx ? (
				<div className="qrcode-box">
					<picture>
						<QRCode value={geneQrCode()} size={qrCodeSize} />
					</picture>
					<p className="tips">获取最佳体验，请扫码分享或直接访问toutube.vphoto.cn</p>
				</div>
			) : (
				''
			)}
		</div>
	);
};
